module.exports = __webpack_public_path__ + "img/purchases--avatar.bee06c90.svg";